/*
	Компілюється у файл
*/
process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');

/*
	Підключаєм конструктор модулів
*/
const mc = require('__libs/ModuleConstructor.js');


/**
	Запускаєм конструктор модулів. Аргументом приймає масив назв vue-компонентів,
	які треба включити в процес збірки проекту.
	@type {Array<String>}
*/
mc(['Slider', 'Navigation', 'slickSlider']);

/*
	Запускаєм скріпти html компонентів
*/
STACK.forEach(f => {
	f($);
})

const counter = require('__libs/counter.js');


counter.init();
$("body").on('ajaxResponse', function() {
})


// запускаєм скріпти які повинні запускатися при ajax
$("body").trigger('ajaxResponse');



// WEBPACK FOOTER //
// ./entries/product.js